import styles from "../styles/HeaderShortcuts.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import NavigationLink from "../navigation/NavigationLink";

type EditableProps = {
  canEdit: true;
  deleteNavigation: (id: number) => void;
  updateNavigation: (navigation: Navigation) => void;
};

type NonEditableProps = {
  canEdit: false;
};

export function Shortcut(
  props: {
    shortcut: Navigation;
    className?: string;
  } & (EditableProps | NonEditableProps),
) {
  return (
    <li className={props.className}>
      <div className={styles.editControls}>
        {props.canEdit && (
          <div>
            <button
              style={{ marginRight: "10px" }}
              title={"Edit Link"}
              onClick={() => props.updateNavigation(props.shortcut)}
            >
              <FontAwesome ariaHidden name={"fa-pen"} prefix={"fas"} />
            </button>
            <button
              title={"Delete Link"}
              onClick={() => props.deleteNavigation(props.shortcut.id)}
            >
              <FontAwesome ariaHidden name={"fa-trash"} prefix={"fas"} />
            </button>
          </div>
        )}
      </div>
      <NavigationLink
        href={props.shortcut.url}
        navigationObj={props.shortcut}
        aria-label={props.shortcut.title}
        className={styles.link}
      >
        <FontAwesome
          fixedWidth
          name={props.shortcut.icon}
          ariaHidden={true}
          className={styles.glyph}
        />
        <div className={styles.label}>
          <div>{props.shortcut.title}</div>
        </div>
      </NavigationLink>
    </li>
  );
}
